import SortableTable from "../../App/Components/Table/SortableTable";
import { ITablePagination } from "../../App/Typings/SortableTable";
import { ITableColumn } from "../../App/Typings/TableColumn";

const defaultPaginationOptions: ITablePagination = {
  rowsPerPage: [10, 15, 25],
  enabled: true,
};

export function MessageTemplateTable<T>({
  name,
  loading,
  columns,
  tableData = [],
  isEditingGroup,
  handleSelected,
  hoverRowEffect = true,
  paginationOptions,
  customOrder,
  customOrderBy,
  customRequestSort,
}: {
  name?: string;
  columns: ITableColumn[];
  loading: boolean;
  tableData: T[];
  isEditingGroup?: boolean;
  handleSelected?: (row: any, select: boolean, e: any) => void;
  hoverRowEffect?: boolean;
  paginationOptions?: Partial<ITablePagination>;
  customOrder?: "asc" | "desc";
  customOrderBy?: string;
  customRequestSort?: (event: React.MouseEvent<unknown>, property: string) => void;
}) {
  return (
    <SortableTable
      name={`message-template-table${name ? `-${name}` : ""}`}
      columns={columns}
      isEditingGroup={isEditingGroup}
      columnEditEnabled={false}
      loading={loading}
      tableData={tableData}
      selected={false}
      pagination={{ ...defaultPaginationOptions, ...paginationOptions }}
      emptyMessage="No records available."
      handleSelected={handleSelected}
      hoverRowEffect={hoverRowEffect}
      rowTitle={(row) => row.name as string}
      getRowId={(row) => (row.emailTemplateId ?? row.textTemplateId ?? row.id ?? "") as string}
      defaultOrderBy={customOrderBy ?? "modifiedDate"}
      customOrder={customOrder}
      customOrderBy={customOrderBy}
      customRequestSort={customRequestSort}
    />
  );
}
